export const FETCH_PHYSICIANS_REQUEST = 'FETCH_PHYSICIANS_REQUEST';
export const FETCH_PHYSICIANS_SUCCESS = 'FETCH_PHYSICIANS_SUCCESS';
export const FETCH_PHYSICIANS_FAILURE = 'FETCH_PHYSICIANS_FAILURE';

export const CREATE_PHYSICIAN_REQUEST = 'CREATE_PHYSICIAN_REQUEST';
export const CREATE_PHYSICIAN_SUCCESS = 'CREATE_PHYSICIAN_SUCCESS';
export const CREATE_PHYSICIAN_FAILURE = 'CREATE_PHYSICIAN_FAILURE';

export const UPDATE_PHYSICIAN_REQUEST = 'UPDATE_PHYSICIAN_REQUEST';
export const UPDATE_PHYSICIAN_SUCCESS = 'UPDATE_PHYSICIAN_SUCCESS';
export const UPDATE_PHYSICIAN_FAILURE = 'UPDATE_PHYSICIAN_FAILURE';

export const DELETE_PHYSICIAN_REQUEST = 'DELETE_PHYSICIAN_REQUEST';
export const DELETE_PHYSICIAN_SUCCESS = 'DELETE_PHYSICIAN_SUCCESS';
export const DELETE_PHYSICIAN_FAILURE = 'DELETE_PHYSICIAN_FAILURE';

export const fetchPhysiciansRequest  = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
        type: FETCH_PHYSICIANS_REQUEST,
        payload: { projectId, page, limit, search },
        
      }; 
    };
export const fetchPhysiciansSuccess = (physicians) => ({ type: FETCH_PHYSICIANS_SUCCESS, payload: physicians });
export const fetchPhysiciansFailure = (error) => ({ type: FETCH_PHYSICIANS_FAILURE, payload: error });

export const createPhysicianRequest = (data,projectId) => ({ type: CREATE_PHYSICIAN_REQUEST, payload:{ data,projectId }});
export const createPhysicianSuccess = (physician) => ({ type: CREATE_PHYSICIAN_SUCCESS, payload: physician });
export const createPhysicianFailure = (error) => ({ type: CREATE_PHYSICIAN_FAILURE, payload: error });

export const updatePhysicianRequest = (id, data,projectId) => ({ type: UPDATE_PHYSICIAN_REQUEST, payload: { id, data,projectId } });
export const updatePhysicianSuccess = (physician) => ({ type: UPDATE_PHYSICIAN_SUCCESS, payload: physician });
export const updatePhysicianFailure = (error) => ({ type: UPDATE_PHYSICIAN_FAILURE, payload: error });

export const deletePhysicianRequest = (id, projectId) => ({ type: DELETE_PHYSICIAN_REQUEST, payload: { id, projectId } });
export const deletePhysicianSuccess = (id) => ({ type: DELETE_PHYSICIAN_SUCCESS, payload: id });
export const deletePhysicianFailure = (error) => ({ type: DELETE_PHYSICIAN_FAILURE, payload: error });
